'use client';

import { type LayoutNode, type LayoutNodeStyleMap } from 'shop-ui/types';
import { ELEMENT_TYPE, FEATURE_FLAG_KEYS } from 'shop-ui/constants';
import { getElementUlId } from 'app/shop-ui/tools/getElementUlId';
import { combineComponent } from 'shop-ui/tools/combineComponent';
import { GRID_LAYOUT_TYPE } from 'shop-ui/section/Grid/rules';
import i18n from '@shared/i18n';

export const componentName = 'Carousel';

export enum OFFICIAL_CAROUSEL_KEY {
    CAROUSEL = 'official-carousel',
}

export const showCutList = [
    {
        key: OFFICIAL_CAROUSEL_KEY.CAROUSEL,
        type: ELEMENT_TYPE.CAROUSEL,
        content: i18n.gettext('輪播'),
        version: 1,
        name: OFFICIAL_CAROUSEL_KEY.CAROUSEL,
    },
];

const config: LayoutNode = {
    id: '',
    type: ELEMENT_TYPE.CAROUSEL,
    name: componentName,
    enable: true,
    next: null,
    deletable: true,
};

export const features = [
    FEATURE_FLAG_KEYS.RESIZE_HANDLE,
    FEATURE_FLAG_KEYS.WITHOUT_CONTAINER_WIDTH,
    FEATURE_FLAG_KEYS.CAROUSEL_MEDIA_LIST,
    FEATURE_FLAG_KEYS.READONLY_CAROUSEL_MEDIA_LIST,
    FEATURE_FLAG_KEYS.CAROUSEL_LINK_TYPE_LIST,
    FEATURE_FLAG_KEYS.CAROUSEL_LINK_LIST,
    FEATURE_FLAG_KEYS.CAROUSEL_SHOULD_OPEN_NEW_WINDOW_LIST,
    FEATURE_FLAG_KEYS.ANIMATION,
];

const defaultStyle = {
    [FEATURE_FLAG_KEYS.WITHOUT_CONTAINER_WIDTH]: true,
    [FEATURE_FLAG_KEYS.CAROUSEL_MEDIA_LIST]: ['', '', ''] as string[],
    [FEATURE_FLAG_KEYS.CAROUSEL_LINK_TYPE_LIST]: ['url', 'url', 'url'] as string[],
    [FEATURE_FLAG_KEYS.CAROUSEL_LINK_LIST]: ['', '', ''] as string[],
    [FEATURE_FLAG_KEYS.CAROUSEL_SHOULD_OPEN_NEW_WINDOW_LIST]: [
        false,
        false,
        false,
    ] as boolean[],
    [FEATURE_FLAG_KEYS.READONLY_CAROUSEL_MEDIA_LIST]: ['', '', ''] as string[],
} as const;

export function createCarousel(presetStyle?: LayoutNodeStyleMap[string]) {
    const id = getElementUlId();

    const layout = {
        ...config,
        id,
    };

    return {
        id,
        layout,
        style: {
            ...defaultStyle,
            ...presetStyle,
        },
    };
}

export function generate(
    sectionName: string = i18n.gettext('區塊'),
    options?: { shouldWrap?: boolean }
) {
    const Carousel = createCarousel();

    const shouldWrap = options?.shouldWrap ?? true;

    return combineComponent(sectionName, [Carousel], {
        primaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
        secondaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
        shouldWrap,
        primaryGridPresetStyle: {
            [FEATURE_FLAG_KEYS.PADDING_LEFT]: '0px',
            [FEATURE_FLAG_KEYS.PADDING_RIGHT]: '0px',
        },
    });
}
